import { useSelector } from '../redux/hooks/useSelector'
import { TraderDiaryByStateOptions } from '../redux/reducers/filters'
import { RootState } from '../redux/reducers/root'
import {
  TRADER_DIARY_CANCELED,
  TRADER_DIARY_PARTIAL_SETTLED,
  TRADER_DIARY_RECEIVED,
  TRADER_DIARY_SETTLED,
} from '../constants/codeLists'
import { TraderDiaryTableRow } from '../redux/reducers/traderDiary'

export const useTraderDiaryFilters = () => {
  const traderDiaries: TraderDiaryTableRow[] = useSelector((state: RootState) => state.traderDiaries.traderDiaries)
  const filters = useSelector((state: RootState) => state.filters)

  let filteredTableRows = traderDiaries.filter(
    (traderDiary: TraderDiaryTableRow) =>
      `${traderDiary.clientFirstname}${traderDiary.clientSurname}`
        .toLowerCase()
        .includes(filters.searchedClientName.toLowerCase()) &&
      (traderDiary.amount || 0) >= filters.searchedAmountUp &&
      (traderDiary.amount || 0) <= (filters.searchedAmountDown === '' ? Infinity : filters.searchedAmountDown) &&
      new Date(traderDiary.creationDate) > filters.searchedDateFrom &&
      new Date(traderDiary.creationDate) < filters.searchedDateTo &&
      `${traderDiary.securityName}`.toLowerCase().includes(filters.searchedInstrumentName.toLowerCase()) &&
      `${traderDiary.currency}`.toLowerCase().includes(filters.searchedCurrencyName.toLowerCase()) &&
      `${traderDiary.orderMarketType}`.toLowerCase().includes(filters.searchedOrderType.toLowerCase())
  )

  switch (filters.sortTraderDiaryBy) {
    case TraderDiaryByStateOptions.Received:
      filteredTableRows = filteredTableRows.filter(row => row.state === TRADER_DIARY_RECEIVED)
      break
    case TraderDiaryByStateOptions.Settled:
      filteredTableRows = filteredTableRows.filter(row => row.state === TRADER_DIARY_SETTLED)
      break
    case TraderDiaryByStateOptions.PartialSettled:
      filteredTableRows = filteredTableRows.filter(row => row.state === TRADER_DIARY_PARTIAL_SETTLED)
      break
    case TraderDiaryByStateOptions.Canceled:
      filteredTableRows = filteredTableRows.filter(row => row.state === TRADER_DIARY_CANCELED)
      break
  }
  return filteredTableRows
}

export const useOrderFiltersDates = () => {
  const traderDiaries: TraderDiaryTableRow[] = useSelector((state: RootState) => state.traderDiaries.traderDiaries)
  const filters = useSelector((state: RootState) => state.filters)

  let filteredTableRows = traderDiaries.filter(
    (order: TraderDiaryTableRow) =>
      new Date(order.creationDate) > filters.searchedDateFrom &&
      new Date(order.creationDate) < filters.searchedDateTo
  )

  return filteredTableRows
}
